import { BrowserRouter } from 'react-router-dom'
import Header from './components/layout/Header'
import Footer from './components/sections/FooterSection'
import AppRouter from './routes/AppRouter'
import MobileMenu from './components/layout/MobileMenu'
import PopupForm from './components/common/PopupForm'
import ScrollToTop from './components/utils/ScrollToTop';
import './index.css';

export default function App() {
  return (
    <div className="font-sans">
      <BrowserRouter>
          <ScrollToTop /> {/* 🔥 important */}
          <Header />
          <MobileMenu />
          <PopupForm />
          <AppRouter />
          <Footer />
      </BrowserRouter>
    </div>
  )
}